import Date from '../../../../components/Date/Date'
import ScriptManaActionsMenu from '../actions-menu/ScriptManaActionsMenu'
import {Link} from 'react-router-dom'

const ScriptsTableRow = ({
  row: data,
  actionOverlay,
  hasWritePermission,
}: {
  row: any
  actionOverlay: any
  hasWritePermission: any
}) => {
  return (
    <>
      <tr>
        <td>
          {hasWritePermission ? (
            <Link to={`/storefronts/script-manager/${data?.id}/${data?.name}`}>
              <span className='text-dark text-hover-primary text-decoration-underline'>
                {data?.name}
              </span>
            </Link>
          ) : (
            <span>{data?.name}</span>
          )}
        </td>
        <td>{data?.description}</td>
        <td className='text-capitalize'>{data?.placement}</td>
        <td>
          <span className='text-capitalize'>{data?.updatedBy}</span>
        </td>
        <td>
          <Date date={data?.updatedAt} />
        </td>
        <td>
          <Date date={data?.createdAt} />
        </td>
        {hasWritePermission && actionOverlay(ScriptManaActionsMenu)}
      </tr>
    </>
  )
}

export default ScriptsTableRow
